<div class="basic-app-tab flex flex-col gap-[30px]">
   <mat-tab-group #matTabGroup>
      <mat-tab label="Project data">
         <div class="app-tab-basic-content flex flex-col gap-[30px]">
            <ep-running-detail-tab
               [endDateFC]="endDateFC"
               [acronymFC]="acronymFC"
               [foundingFC]="foundingFC"
               [durationFC]="durationFC"
               [startDateFC]="startDateFC"
               [currentMonthFC]="currentMonthFC"
               [typeOfActionFC]="typeOfActionFC"
               [typeOfActionArray]="typeOfActionArray"
               [fundingAgreementIdFC]="fundingAgreementIdFC"
               [callOfTheProposalFC]="callOfTheProposalFC"
               [generalObjectivesFC]="generalObjectivesFC"
               [fundingAssociatedNameFC]="fundingAssociatedNameFC"
            ></ep-running-detail-tab>
            <div class="flex gap-3 justify-center">
               <p-button
                  styleClass="basic-accent-1-button w-[100px] h-[32px] whitespace-nowrap font-semibold"
                  label="Save"
                  (click)="updateProjectClick()"
               >
               </p-button>
            </div>
         </div>
      </mat-tab>
      <mat-tab label="Project logo">
         <div class="app-tab-basic-content">
            <ep-running-logo
               [logo]="logo"
               [isLoadingLogo]="isLoadingLogo"
               (doActionSave)="doActionSaveLogo.emit($event)"
               (doActionDeleteLogo)="doActionDeleteLogo.emit()"
               (hasUnsavedChanges)="hasUnsavedChanges.emit($event)"
            ></ep-running-logo></div
      ></mat-tab>
      <mat-tab label="Reporting period">
         <div class="app-tab-basic-content">
            <ep-running-reporting-period
               [project]="project"
               [reportingPeriodsRes]="reportingPeriodsRes"
               [isLoadingReportingPeriods]="isLoadingReportingPeriods"
               [endMonthFC]="reportingEndMonthFC"
               [nextPeriodFC]="reportingNextPeriodFC"
               [nextStartMonthFC]="reportingNextStartMonthFC"
               (addReportClick)="doActionAddReport()"
               (deleteReportClick)="deleteReportClick.emit()"
            ></ep-running-reporting-period></div
      ></mat-tab>
   </mat-tab-group>
</div>

<app-basic-confirm-dialog></app-basic-confirm-dialog>
